import { microserviceClient } from '../../api-clients';

export const postProductUpdate = async (leadId: string|undefined, productId: string): Promise<void> => {
    microserviceClient.post(
        `${process.env.REACT_APP_DEFAULT_API_BASE_URL}/api/application/lead/${leadId}/updateProduct`, {
            'productId': productId,
        }
    );
};
